var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachmentRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1953,
    cy: 12.6094,
    r: 12.5,
    fill: "#FFF6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3055_48453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.19496 6.60653L19.195 18.6065M20.695 12.6065L16.735 16.5665M15.445 17.8565C15.445 17.8565 14.5399 18.7616 13.945 19.3565C9.44496 23.8565 2.69496 17.1065 7.19496 12.6065C7.85909 11.9424 8.69496 11.1065 8.69496 11.1065M10.195 9.60653C10.195 9.60653 11.8161 7.98537 13.945 5.85653C16.945 2.85653 21.445 7.35653 18.445 10.3565C16.9355 11.866 14.695 14.1065 14.695 14.1065M13.195 15.6065C13.195 15.6065 12.1808 16.6207 11.695 17.1065C10.195 18.6065 7.94496 16.3565 9.44496 14.8565C9.82033 14.4812 10.945 13.3565 10.945 13.3565M12.445 11.8565C12.2491 12.0524 16.195 8.10653 16.195 8.10653",
    stroke: "#DF0000",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3055_48453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4.19531 3.60938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentRed);
export default __webpack_public_path__ + "static/media/attachment-red.968f6ba6403083e3bc204b9e19354e78.svg";
export { ForwardRef as ReactComponent };